// src/components/library/TrackList.jsx
import React from 'react';
import { useLibrary } from '../../context/LibraryContext';
import { useAudio } from '../../context/AudioContext';

const TrackList = ({ releaseId }) => {
  const { getTracksByReleaseId } = useLibrary();
  const { currentTrack, setCurrentTrack, isPlaying, togglePlay } = useAudio();
  
  const tracks = getTracksByReleaseId(releaseId);
  
  const handlePlayTrack = (track) => {
    if (currentTrack && currentTrack.id === track.id) {
      togglePlay();
    } else {
      setCurrentTrack(track);
    }
  };
  
  return (
    <div className="space-y-2">
      {tracks.map((track) => (
        <div 
          key={track.id} 
          className={`flex items-center p-3 rounded-lg ${
            currentTrack && currentTrack.id === track.id 
              ? 'bg-purple-900' 
              : 'bg-gray-700 hover:bg-gray-600'
          } transition-colors cursor-pointer`}
          onClick={() => handlePlayTrack(track)}
        >
          <div className="mr-4 w-10 h-10 flex-shrink-0 flex items-center justify-center">
            {currentTrack && currentTrack.id === track.id ? (
              isPlaying ? (
                <svg className="w-8 h-8 text-purple-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              ) : (
                <svg className="w-8 h-8 text-purple-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              )
            ) : (
              <svg className="w-8 h-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            )}
          </div>
          <div className="flex-grow">
            <h4 className="text-gray-100 font-medium">{track.title}</h4>
            <p className="text-sm text-gray-400">Track {track.trackNumber}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrackList;